import axios from 'config/axios';

const prefix = 'htmlTemplatesManagement';

export default class HtmlTemplatesManagementSrv {
  static getForGrid(dataState) {
    return axios
      .post(`${prefix}/getForGrid`, dataState)
      .then(result => result.data);
  }

  static get(id) {
    return axios.get(`${prefix}/${id}`).then(result => result.data);
  }

  static add(model) {
    return axios.post(prefix, model);
  }

  static update(model) {
    return axios.put(prefix, model);
  }

  static getPlaceholders(id) {
    return axios
      .get(`${prefix}/${id}/placeholders`)
      .then(result => result.data);
  }
}
